import { View } from 'react-native'

import { Placeholder, PlaceholderLine } from '@/src/elements/placeholder'
import { TEST_ID } from '@/src/general/constants/testId'

export const IntentionFormButtonPlaceholder = () => (
  <Placeholder testID={TEST_ID.INTENTIONS.FORM.LOADING} className="flex-col">
    <View className="flex-1 flex-row justify-between">
      <PlaceholderLine className="max-w-32" />
      <PlaceholderLine className="max-w-8 rounded-xl" />
    </View>
    <PlaceholderLine className="my-4 w-full" size="lg" />
    <View className="flex-1 flex-row justify-between">
      <PlaceholderLine className="max-w-8 rounded-xl" />
      <PlaceholderLine className="max-w-8 rounded-xl" />
    </View>
  </Placeholder>
)
